/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SyncedAgentUser = {
  /**
   * Email the device agent reported on sync. Resolve against org members for display.
   */
  email: string;
  /**
   * First time this email was seen syncing the device agent.
   */
  firstSeenAt: Date;
  /**
   * Most recent time this email was seen syncing the device agent.
   */
  lastSeenAt: Date;
};

/** @internal */
export const SyncedAgentUser$inboundSchema: z.ZodMiniType<
  SyncedAgentUser,
  unknown
> = z.pipe(
  z.object({
    email: z.string(),
    first_seen_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    last_seen_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "first_seen_at": "firstSeenAt",
      "last_seen_at": "lastSeenAt",
    });
  }),
);

export function syncedAgentUserFromJSON(
  jsonString: string,
): SafeParseResult<SyncedAgentUser, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SyncedAgentUser$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SyncedAgentUser' from JSON`,
  );
}
